import { render, staticRenderFns } from "./pago_declaracion.vue?vue&type=template&id=6c395a51&scoped=true"
import script from "./pago_declaracion.js?vue&type=script&lang=js&external"
export * from "./pago_declaracion.js?vue&type=script&lang=js&external"
import style0 from "./pago_declaracion.vue?vue&type=style&index=0&id=6c395a51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c395a51",
  null
  
)

export default component.exports